import { IntRange1cx8zvxgibbj2 as IntRange } from '../ranges/PrimitiveRanges.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function numberRangeToNumber(start, endInclusive) {
  return new (IntRange())(start, endInclusive);
}
//region block: exports
export {
  numberRangeToNumber as numberRangeToNumber25vse2rgp6rs8,
};
//endregion

//# sourceMappingURL=rangeTo.mjs.map
